import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Typography } from '@mui/material';

import api from 'api';
import { useRequest } from 'shared/hooks';
import LoadingSpinner from 'shared/components/feedback/LoadingSpinner/LoadingSpinner';
import { FlexBoxColumnCenter } from 'styles/layout';

import PowerBIReport from './components/PowerBIReport';

const Container = styled.div`
  height: calc(100vh - 130px);
`;

const AnalyticsDashboard = ({ serviceLine }) => {
  const { doRequest, data, isLoading, error } = useRequest(
    api.getAnalyticsDashboardUrl,
  );

  useEffect(() => {
    doRequest(serviceLine);
  }, [serviceLine, doRequest]);

  if (isLoading) {
    return (
      <FlexBoxColumnCenter height="100%">
        <LoadingSpinner />
      </FlexBoxColumnCenter>
    );
  }

  if (error) {
    return (
      <FlexBoxColumnCenter height="100%">
        <Typography color="error">Failed to load the dashboard.</Typography>
      </FlexBoxColumnCenter>
    );
  }

  if (!data?.embedUrl) return null;

  return (
    <Container>
      <PowerBIReport
        embedUrl={data.embedUrl}
        embedToken={data.embedToken}
        reportId={data.reportId}
        serviceLine={serviceLine}
        tokenExpiry={data.tokenExpiry}
      />
    </Container>
  );
};

AnalyticsDashboard.propTypes = {
  serviceLine: PropTypes.string.isRequired,
};

export default AnalyticsDashboard;
